export enum EVENT_TRACKERS {
	GTM = 'GTM',
	Facebook = 'Facebook',
	TikTok = 'TikTok',
	Pinterest = 'Pinterest',
	VervBI = 'VervBI',
}
